import { watch, onBeforeUnmount, onMounted } from '@vue/composition-api';

const SCROLL_POS_KEY = 'tariffOverlayScrollY';
const LOCK_CLASS = 'tariff-overlay-active';

function lockScroll() {
  const html = document.documentElement;
  const { body } = document;
  const app = document.getElementById('app');
  const theme = document.getElementById('huntica-theme');
  const scrollY = window.scrollY || window.pageYOffset;

  body.dataset[SCROLL_POS_KEY] = String(scrollY);
  body.classList.add(LOCK_CLASS);
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.overflow = 'hidden';
  html.style.overflow = 'hidden';
  if (app) app.style.overflow = 'hidden';
  if (theme) theme.style.overflow = 'hidden';
}

function unlockScroll() {
  const html = document.documentElement;
  const { body } = document;
  const app = document.getElementById('app');
  const theme = document.getElementById('huntica-theme');
  const scrollY = Number(body.dataset[SCROLL_POS_KEY] || 0);

  body.classList.remove(LOCK_CLASS);
  body.style.position = '';
  body.style.top = '';
  body.style.left = '';
  body.style.right = '';
  body.style.overflow = '';
  html.style.overflow = '';
  if (app) app.style.overflow = '';
  if (theme) theme.style.overflow = '';
  delete body.dataset[SCROLL_POS_KEY];
  window.scrollTo(0, scrollY);
}

export default function useScrollLock(lockedRef) {
  let isCurrentlyLocked = false;

  const updateLock = (shouldLock) => {
    if (shouldLock && !isCurrentlyLocked) {
      lockScroll();
      isCurrentlyLocked = true;
    } else if (!shouldLock && isCurrentlyLocked) {
      unlockScroll();
      isCurrentlyLocked = false;
    }
  };

  onMounted(() => {
    updateLock(lockedRef.value);
  });

  watch(
    lockedRef,
    (locked) => {
      updateLock(locked);
    },
    { flush: 'post' },
  );

  onBeforeUnmount(() => {
    unlockScroll();
    isCurrentlyLocked = false;
  });
}

export { lockScroll, unlockScroll };
